/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 21,
    height: 23,
    viewBox: '0 0 21 23',
    data: '<path pid="0" d="M9.677 16.928v-2.915H6.124a.905.905 0 0 1-.905-.905V1.461c0-.5.405-.905.905-.905h6.074c.24 0 .47.095.64.265l2.033 2.033c.17.17.265.4.265.64v9.614c0 .5-.405.905-.905.905h-3.554v2.915l1.68-1.68.708.707-2.888 2.887-2.887-2.887.707-.707 1.68 1.68zm1-3.915h3.46V4.34h-1.789a.997.997 0 0 1-.997-.996V1.556H6.22v11.457h3.458V9.267h1v3.746zm1.674-11.265V3.34h1.592l-1.592-1.592zm6.803 14.737h1v4.944c0 .821-.665 1.487-1.486 1.487H1.687c-.82 0-1.486-.666-1.486-1.487v-4.944h1v4.944c0 .269.217.487.486.487h16.98a.486.486 0 0 0 .487-.487v-4.944z" _fill="#454545" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/download.js